import { render, staticRenderFns } from "./BillView.vue?vue&type=template&id=47bba07f&scoped=true"
import script from "./BillView.vue?vue&type=script&lang=js"
export * from "./BillView.vue?vue&type=script&lang=js"
import style0 from "./BillView.vue?vue&type=style&index=0&id=47bba07f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bba07f",
  null
  
)

export default component.exports